import {Component, OnInit, Input, NO_ERRORS_SCHEMA, NgModule, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Itemlist} from '../itemlist';
import {ItemlistService} from '../itemlist.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {CityService} from "../../../../services/city.service";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ParentShowComponent} from "../../../../components/parent-show";
import {ItemService} from "../../../../views/setting/items/items.service";



@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule,TranslateModule.forChild()
    ],
    declarations: [
        ItemlistsShowComponent
    ],
    entryComponents: [
        ItemlistsShowComponent
    ],
    exports: [],
    providers: [SharedService, ItemlistService, CityService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-itemlists-show',
    templateUrl: './itemlists-show.component.html',
    styleUrls: ['./itemlists-show.component.scss'],
    providers: [ItemlistService, CityService, ConfirmationService, MessageService]
})

export class ItemlistsShowComponent implements OnInit, AfterViewInit {
    id: string;
    itemlist: Itemlist;
  items: any[] = [];
    applog: AppLogComponent;
    @Input() refShow;
  @Input() modelName;
    parent:any;
    modalRef: NgbModalRef;


    cities: any[] = [];
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private cityService: CityService,
                private modalService: NgbModal,
                private itemlistService: ItemlistService,
                private itemservice: ItemService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            { label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton' },
            { label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton' },
            { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
            { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
            { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
        ]);
        this.sharedservice.setModelName('');

    }
ngAfterViewInit(){
    this._editButton = document.getElementById('editButton');
    this._deleteButton = document.getElementById('deleteButton');
    this._newButton = document.getElementById('newButton');
    this._printButton = document.getElementById('printButton');
    this._searchButton = document.getElementById('searchButton');

    if(this._editButton) {
        this._editButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/itemlists/edit', this.id]);
        });
    }
    if(this._deleteButton) {
    this._deleteButton.onclick = ((e: any) => {
        e.preventDefault();
        this.deleteItemlist(this.itemlist);
    });}
    if(this._newButton) {
        this._newButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/itemlists']);
        });
    }
    if(this._searchButton) {
        this._searchButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/itemlists/search']);
        });

    }

}
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.itemlist;
        modalRef.componentInstance.rowId = '';

    }
    showParent(){
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open("", options);
        this.modalRef.componentInstance.scrId = this.parent;

        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
    }
    ngOnInit() {
      this.itemservice.getAllItems().subscribe(
        items => {
          this.items = items.itemslist;
          //this.items_enhance = items.itemstable;
          //console.log(this.allitems);
          //console.log(this.items_enhance);

        });
        this.cityService.getAllCities().subscribe(
            cities => {
                this.cities = cities;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
          item_id: new FormControl({value: '', disabled: true}),
          item_name: new FormControl({value: '', disabled: true}),


        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.itemlistService.getById(this.id).subscribe(
                itemlist => {
                    this.id = itemlist.id;
                    this.itemlist = itemlist;
                    this.parent = itemlist.city_id;
                    this.form.patchValue({
                        id: itemlist.id,
                      item_id: itemlist.item_id,
                      item_name: itemlist.item_name,

                    });
                }, error => {
                    console.log(error);
                }
            );

        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.itemlistService.getTrashedById(this.delId).subscribe(
                itemlist => {
                    this.id = itemlist.id;
                    this.itemlist = itemlist;
                    this.form.patchValue({
                      id: itemlist.id,
                      item_id: itemlist.item_id,
                      item_name: itemlist.item_name,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.itemlist = this.newData;

            this.form.patchValue({
              id: this.newData.id,
              item_id: this.newData.item_id,
              item_name: this.newData.item_name,
            });
        }
    }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.itemlists.'+role) >= 0) {
            return true;
        }
        return false;
    }

    deleteItemlist(itemlist: Itemlist) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (itemlist) {
                    this.itemlistService.delete(itemlist.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=> {
                                this.router.navigate(['/itemlists']);
                              },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                            }
                    );
                }
            }
        });
    }

    recoverEdit(itemlist: Itemlist) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (itemlist) {
                    this.itemlistService.update(itemlist).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/itemlists/show', itemlist.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.itemlistService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/itemlists/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = ItemlistsShowComponent;

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/pos/itemlists/itemlists-show/itemlists-show.component.ts